import React, { useEffect, useState } from 'react';
import styles from '@/components/IntegrationExport/TMSCard/styles';
import { Grid, CircularProgress } from '@material-ui/core';
import Select from 'react-select';
import {
  adminChangeTmsTypeAutobook,
  adminGetTmsList,
  SaveApiResMessage,
} from '@/actions';
import EmailForm from './EmailForm';

export default ({
  setActiveTms,
  activeTms,
  state,
  tmsType,
  setTmsType,
  selectedCompany,
  tmsExcelMode,
  setTmsExcelMode,
  excelConfigData,
}) => {
  const cls = styles();
  const [tmsList, setTmsList] = useState([]);
  const ftpUrl =
    typeof process !== 'undefined' && process?.env?.REACT_APP_FTP_URL
      ? process.env.REACT_APP_FTP_URL
      : '';

  useEffect(() => {
    adminGetTmsList()
      .then((data) => {
        let options = data.map((item) => ({
          value: item.slug,
          label: item.name,
        }));
        setTmsList(options);
      })
      .catch((err) => {
        SaveApiResMessage({ title: 'Error', message: err, mode: 'warning' });
      });
  }, []);

  const handleSelectTmsType = (item) => {
    adminChangeTmsTypeAutobook(item.value, selectedCompany.value).then(() => {
      setTmsType(item);
    });
  };

  return (
    <div className={cls.card}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Select
            isClearable
            placeholder="List of TMS"
            className={cls.select}
            value={tmsType}
            onChange={(item) => handleSelectTmsType(item)}
            options={tmsList}
          />
        </Grid>
        {tmsType && (
          <Grid item xs={12} sm={6}>
            <Select
              isClearable
              placeholder="Excel Mode"
              className={cls.select}
              value={tmsExcelMode}
              onChange={(item) => setTmsExcelMode(item)}
              options={[
                { label: 'Email', value: 'Email' },
                { label: 'FTP', value: 'FTP' },
              ]}
            />
          </Grid>
        )}
      </Grid>
      <div className={`${cls.infoContainer} ${activeTms ? cls.blackText : cls.grayText}`}>
        {state.loading ? (
          <div className={cls.loaderContainer}>
            <CircularProgress className={cls.loader} />
          </div>
        ) : (
          <>
            {tmsExcelMode && tmsExcelMode.value === 'Email' && (
              <EmailForm
                selectedCompany={selectedCompany}
                DATA={excelConfigData || state.DATA}
              />
            )}
            {tmsExcelMode && tmsExcelMode.value === 'FTP' && (
              <>
                <div className={cls.info}>
                  <span className={cls.infoTitle}>FTP Username:</span>
                  <span className={cls.infoDesc}>{state.DATA.ftp_username || ''}</span>
                </div>
                <div className={cls.info}>
                  <span className={cls.infoTitle}>FTP Password:</span>
                  <span className={cls.infoDesc}>{state.DATA.ftp_password || ''}</span>
                </div>
                <div className={cls.info}>
                  <span className={cls.infoTitle}>Server Address:</span>
                  <span className={cls.infoDesc}>
                    {state.DATA.ftp_username ? ftpUrl : ''}
                  </span>
                </div>
                <div className={cls.info}>
                  <span className={cls.infoTitle}>Server Port:</span>
                  <span className={cls.infoDesc}>{state.DATA.ftp_username ? '21' : ''}</span>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};
